<c-card *transloco="let t">
  <c-card-body class="px-2">

          <c-row>
            <c-col md="12">
              <h1>{{ t('Your OK Alone Features') }}</h1>
              <p>
                  {{ t('OK Alone has many features available to help manage and keep your lone workers safe. You can use this page to customize your Dashboard view and also toggle app features to be used by your lone workers in the app.') }}
              </p>

            </c-col>
          </c-row>

          <div class="row">
              <div class="col">
                <div class="btn-group" role="group" aria-label="Basic mixed styles example">
                  <button type="button" class="btn btn-outline-success" (click)="enableRecommended()"><i class="fa-solid fa-wand-magic-sparkles"></i> {{ t('Enable Recommended Features') }}</button>
                  <button type="button" class="btn btn-outline-primary" (click)="enableAll()"><i class="fa-solid fa-clipboard-check"></i> {{ t('Enable All Features') }}</button>
                  <button type="button" class="btn btn-outline-secondary" (click)="enableUndo()" *ngIf="changed"><i class="fa-solid fa-rotate-left"></i> {{ t('Undo Feature Changes') }}</button>
                </div>



                  <br/><br/>
              </div>
          </div>


          <ng-container *ngIf="formGroup">



          <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()">

              <div class="row">
                  <div class="col">
                      <div class="card mb-3">
                          <div class="card-header">
                            {{ t('Dashboard Features') }}
                          </div>
                          <ul class="list-group list-group-flush">
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="groups" id="groups">
                                      <label class="form-check-label d-inline d-inline" for="groups">
                                        <b>{{ t('Groups') }}</b> {{ t('Organize your workers into groups with similar settings such as check in frequency and monitors.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/mgmt/groups/groups" *ngIf="features.groups">{{ t('View') }}</button>

                                  </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['groups']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['groups']}}
                                  </div>
                              </li>
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="timesheets" id="timesheets">
                                      <label class="form-check-label d-inline" for="timesheets">
                                        <b>{{ t('Timesheets') }}</b> {{ t('Generate and export timesheets for your workers using the shifts worked in OK Alone.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/reports/timesheets" *ngIf="features.timesheets">{{ t('View') }}</button>
                                  </div>
                              </li>
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="worker_reports" id="worker_reports">
                                      <label class="form-check-label d-inline" for="worker_reports">
                                        <b>{{ t('Reports') }}</b> {{ t('View a range of reports about your workers\' usage of OK Alone, including usage stats, worker status and shift information. Reports can be exported as needed or sent out on a regular schedule.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/reports/worker-reports" *ngIf="features.worker_reports">{{ t('View') }}</button>
                                  </div>
                              </li>
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="safety_awards" id="safety_awards">
                                      <label class="form-check-label d-inline" for="safety_awards">
                                        <b>{{ t('Safety Awards') }}</b> {{ t('Safety Awards offer an engaging way to stay safe, while using the lone worker system to compete with colleagues and companies across the world.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/awards/awards-home" *ngIf="features.safety_awards">{{ t('View') }}</button>
                                  </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['safety_awards']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['safety_awards']}}
                                  </div>
                              </li>
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="access" id="access">
                                      <label class="form-check-label d-inline" for="access">
                                        <b>{{ t('Roles') }}</b> {{ t('Roles limit what a Monitor sees or accesses on the OK Alone dashboard.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" (click)="goToMonitor()" *ngIf="features.access">{{ t('View') }}</button>
                                  </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['access']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['access']}}
                                  </div>
                              </li>
                              <li class="list-group-item" *ngIf="okService.settings.call_center_available">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="live_monitoring" id="live_monitoring">
                                      <label class="form-check-label d-inline" for="live_monitoring">
                                        <b>{{ t('Call Center Plan') }}</b> {{ t('Our call center can respond to your alerts 24/7 and respond appropriately following your escalation procedure.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/settings/live" *ngIf="features.live_monitoring">{{ t('View') }}</button>
                                  </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['live_monitoring']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['live_monitoring']}}
                                  </div>
                              </li>
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="safety_zones" id="safety_zones">
                                      <label class="form-check-label d-inline" for="safety_zones">
                                        <b>{{ t('Safety Zones') }}</b> {{ t('A safety zone can be created for each worker. If they leave this zone then an alert can be sent to monitors.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/mgmt/safetyzones" *ngIf="features.safety_zones">{{ t('View') }}</button>
                                  </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['safety_zones']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['safety_zones']}}
                                  </div>
                              </li>
                              <li class="list-group-item">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" formControlName="auto_end_shift" id="auto_end_shift">
                                    <label class="form-check-label d-inline" for="auto_end_shift">
                                      <b>{{ t('Auto End Shifts') }}</b> {{ t("Set a time at which all workers' shifts will automatically end each day.") }}
                                    </label>
                                    <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/settings/settings" *ngIf="features.auto_end_shift">{{ t('View') }}</button>
                                </div>
                                <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['auto_end_shift']">
                                  &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['auto_end_shift']}}
                                </div>
                              </li>
                              @if(okService.isSuperAdmin()){
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="map_zones" id="map_zones">
                                      <label class="form-check-label d-inline" for="map_zones">
                                        <b>{{ t('Map Zones') }}</b> {{ t('Multiple map zones can be created and workers assigned to these zones to help identify their location.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/mgmt/safetyzones" *ngIf="features.map_zones">{{ t('View') }}</button>
                                  </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['map_zones']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['map_zones']}}
                                  </div>
                              </li>
                              }
                              @if(okService.isSuperAdmin()){
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="action_notices" id="action_notices">
                                      <label class="form-check-label d-inline" for="map_zones">
                                        <b>{{ t('Action Notices') }}</b> {{ t('Action Notices are informational notifications sent to monitors when actions are performed such as shifts starting and shifts ending.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/settings/settings" *ngIf="features.action_notices">{{ t('View') }}</button>
                                  </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['action_notices']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['action_notices']}}
                                  </div>
                              </li>
                              }
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="learning_center" id="learning_center">
                                      <label class="form-check-label d-inline" for="learning_center">
                                        <b>{{ t('Learning Center') }}</b> {{ t('The Learning Center helps monitors and workers understand best practices for lone working, and explains how OK Alone helps keep them safe. ') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/mgmt/learning-center" *ngIf="features.learning_center">{{ t('View') }}</button>
                                  </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['learning_center']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['learning_center']}}
                                  </div>
                              </li>
                              <li class="list-group-item">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" formControlName="flex_delay" id="flex_delay">
                                    <label class="form-check-label d-inline" for="flex_delay">
                                      <b>{{ t('Flexible Grace Period / Alert Delay') }}</b> {{ t('Set an alternate grace period / alert delay period for High Risk Check-ins and Man/Worker Down.') }}
                                    </label>
                                    <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/settings/settings" *ngIf="features.flex_delay">{{ t('View') }}</button>
                                  </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['flex_delay']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['flex_delay']}}
                                  </div>
                              </li>
                              <li class="list-group-item">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" formControlName="force_password_reset" id="force_password_reset">
                                    <label class="form-check-label d-inline" for="force_password_reset">
                                      <b>{{ t('Force Password Reset') }}</b> {{ t('Set an amount of time, after which your monitors need to change their passwords.') }}
                                    </label>
                                    <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/settings/settings" *ngIf="features.force_password_reset">{{ t('View') }}</button>
                                  </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['force_password_reset']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['force_password_reset']}}
                                  </div>
                              </li>
                              @if(okService.isSuperAdmin()){
                              <li class="list-group-item">
                                <div class="form-check">
                                  <input class="form-check-input" type="checkbox" formControlName="privacy_mode" id="privacy_mode">
                                  <label class="form-check-label d-inline" for="privacy_mode">
                                    <b>&nbsp;{{ t('Privacy Mode') }}</b> {{ t('Worker locations are hidden in the dashboard unless they have an active alert.') }}
                                  </label>
                                </div>
                              </li>
                            }
                          </ul>
                      </div>
                  </div>
                  <div class="col">

                    <div class="card mb-3" *ngIf="(okService.settings.country == 'CA' || okService.settings.country == 'US') && !okService.settings.call_center_available">
                      <div class="card-header">
                        {{ t('Safety Monitoring Center') }}
                      </div>
                      <ul class="list-group list-group-flush">

                        <li class="list-group-item list-group-item-info">
                          <b>Get Immediate 24/7 Emergency Help, Faster Than 911.</b><br/>
                          Protect your people 24/7 with our Safety Monitoring Center service that delivers:<br/>
                            <ul>
                              <li>Immediate emergency help directly to your pinpoint location, across US & Canada.</li>
                              <li>Professionally trained agents who know how to react quickly and calmly in a crisis</li>
                              <li>Customized help based on your unique escalation plans.</li>
                          </ul>
                          <a href="https://www.okaloneworker.com/ppc-landing-page/" target="_new">Learn more about the Safety Monitoring Center</a>
                        </li>

                        <li class="list-group-item">
                          <div class="form-check">
                              <input class="form-check-input" type="checkbox" formControlName="enhanced_monitoring" id="enhanced_monitoring">
                              <ng-container class="form-check-label d-inline" for=" disabled">
                                <b>{{ t('Safety Monitoring Center') }}</b> {{ t('Our Safety Monitoring Center ensures your people are always protected.') }}
                              </ng-container> 
                              @if(!okService.settings.arc_on){
                                <br/><i class="fa-solid fa-triangle-exclamation"></i> {{ t('Want to add the Safety Monitoring Center to your account? Please email') }}
                                @if(okService.billing.live){
                                  <a href="customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>
                                }@else{
                                  <a href="sales@ok-alone.com" target="_new">sales&#64;ok-alone.com</a>
                                }
                              }
                            </div>
                        </li>
                      </ul>
                      </div>


                      <div class="card mb-3">
                          <div class="card-header">
                            {{ t('Comms Plan') }}
                          </div>
                          <ul class="list-group list-group-flush">

                            <li class="list-group-item list-group-item-info" *ngIf="!this.okService.billing.live && !this.okService.billing.trial_over"><!-- free trial -->
                              <i class="fa-solid fa-triangle-exclamation"></i> {{ t('To use these features your company must have the Comms Plan active on their account. Find out about the Comms Plan ') }}<a href="https://www.okaloneworker.com/what-is-the-comms-plan/" target="_new">{{ t('here') }}</a>
                            </li>

                            <li class="list-group-item list-group-item-info" *ngIf="this.okService.billing.live && this.okService.billing.plan.comms"><!-- comms plan on -->
                              <i class="fa-solid fa-triangle-exclamation"></i> {{ t('You have the Comms Plan and can use these features.') }}<br />
                              {{ t('Learn more about the Comms Plan') }}&nbsp;<a href="https://www.okaloneworker.com/what-is-the-comms-plan/" target="_new">{{ t('here') }}</a>
                            </li>

                            <li class="list-group-item list-group-item-info" *ngIf="this.okService.billing.live && !this.okService.billing.plan.comms"><!-- comms plan off -->
                              <i class="fa-solid fa-triangle-exclamation"></i> {{ t('You currently do not have the Comms Plan active, to set it up please go to your') }} <a routerLink="/account">{{ t('Account Settings') }}</a>
                              {{ t('Learn more about the Comms Plan') }}&nbsp;<a href="https://www.okaloneworker.com/what-is-the-comms-plan/" target="_new">{{ t('here') }}</a>
                            </li>

                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="checkin_reminders" id="checkin_reminders">
                                      <label class="form-check-label d-inline" for="checkin_reminders">
                                        <b>{{ t('Check In Reminders') }}</b> {{ t('Workers can get SMS to remind them to check in, helping reduce false alerts.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" (click)="goToWorker('checkin')" *ngIf="features.checkin_reminders">{{ t('View') }}</button>
                                    </div>
                                    <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['checkin_reminders']">
                                      &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['checkin_reminders']}}
                                    </div>
                                </li>
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="out_of_hours" id="out_of_hours">
                                      <label class="form-check-label d-inline" for="out_of_hours">
                                        <b>{{ t('Out of Hours Monitoring') }}</b> {{ t('Choose different monitors that should be alerted if the alert occurs out of normal business hours.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/mgmt/outofhours" *ngIf="features.out_of_hours">{{ t('View') }}</button>
                                    </div>
                                    <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['out_of_hours']">
                                      &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['out_of_hours']}}
                                    </div>
                                </li>
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="alert_loops" id="alert_loops">
                                      <label class="form-check-label d-inline" for="alert_loops">
                                        <b>{{ t('Alert Loops') }}</b> {{ t('Monitors for a worker can be set up to be alerted in an automated, timed sequence which continues until a monitor accepts the alert.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/mgmt/alertloops/alertloops" *ngIf="features.alert_loops">{{ t('View') }}</button>
                                    </div>
                                    <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['alert_loops']">
                                      &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['alert_loops']}}
                                    </div>
                                </li>
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="start_end_shift" id="start_end_shift">
                                      <label class="form-check-label" for="start_end_shift">
                                        <b>{{ t('Start / End Shift Reminders') }}</b> {{ t('Workers can have reminders to start and end their shifts via SMS, email, or phonecall.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0"  (click)="goToWorker('shift')" *ngIf="features.start_end_shift">{{ t('View') }}</button>
                                  </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['start_end_shift']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['start_end_shift']}}
                                  </div>
                              </li>
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="email_reminder" id="email_reminder">
                                      <label class="form-check-label d-inline" for="email_reminder">
                                        <b>{{ t('Email Check In Reminders') }}</b> {{ t('Workers can get email to remind them to check in, helping reduce false alerts.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" (click)="goToWorker('checkin')" *ngIf="features.email_reminder">{{ t('View') }}</button>
                                    </div>
                                    <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['email_reminder']">
                                      &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['email_reminder']}}
                                    </div>
                                </li>
                                <li class="list-group-item">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" formControlName="send_messages" id="send_messages">
                                        <label class="form-check-label d-inline" for="send_messages">
                                          <b>{{ t('Mass Notifications') }}</b> {{ t('Send a mass notification to workers or monitors via SMS/email.') }}
                                        </label>
                                        <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/mgmt/send-messages" *ngIf="features.send_messages">{{ t('View') }}</button>
                                      </div>
                                      <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['send_messages']">
                                        &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['send_messages']}}
                                      </div>
                                </li>
                                <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="fa2" id="fa2">
                                      <label class="form-check-label d-inline" for="fa2">
                                        <b>{{ t('Monitor Multi-Factor Authentication') }}</b> {{ t('Enable Multi-Factor Authentication for monitors. Monitors receive a one-time passcode by SMS or email to verify their identity.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/settings/settings" *ngIf="features.fa2">{{ t('View') }}</button>
                                  </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['fa2']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['fa2']}}
                                  </div>
                              </li>
                          </ul>
                      </div>
                  </div>
              </div>

              <div class="row">
                  <div class="col">
                      <div class="card">
                          <div class="card-header">
                            {{ t('App Features') }}
                          </div>
                          <ul class="list-group list-group-flush">

                            <li class="list-group-item list-group-item-info">
                              <i class="fa-solid fa-triangle-exclamation"></i> {{ t('To make changes to your App Features please contact the OK Alone team at ') }}<a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>
                            </li>

                            <li class="list-group-item">
                              <div class="form-check">
                                  <input class="form-check-input" type="checkbox" formControlName="timer" id="timer">
                                  <label class="form-check-label d-inline" for="timer">
                                    <b>{{ t('Check In Timer') }}</b> {{ t('The app checks the worker is ok at a regular time, such as every 2 hours.') }}
                                  </label>
                                  <button type="button" class="btn btn-link d-inline p-0 m-0" (click)="goToWorker('checkin')" *ngIf="features.spot">{{ t('View') }}</button>
                                </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['timer']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['timer']}}
                                  </div>
                            </li>
                            <li class="list-group-item">
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" formControlName="checkin" id="checkin">
                                <label class="form-check-label d-inline" for="checkin">
                                  <b>{{ t('Check In Button') }}</b> {{ t('Allow the worker to check in using the app to confirm they are ok.') }}
                                </label>
                              </div>
                          </li>
                          <li class="list-group-item">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" formControlName="highrisk" id="highrisk">
                              <label class="form-check-label d-inline" for="highrisk">
                                <b>{{ t('High Risk Check Ins') }}</b> {{ t('The worker can set a reduced check in time, such as 30 minutes, if they enter an area of high risk.') }}
                              </label>
                            </div>
                        </li>
                        <li class="list-group-item">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" formControlName="mandown" id="mandown">
                            <label class="form-check-label d-inline" for="mandown">
                              <b>{{ t('Man Down Detection') }}</b> {{ t('The app will detect a lack of movement and create an alert if the worker does not confirm they are ok.') }}
                            </label>
                          </div>
                      </li>
                      <li class="list-group-item">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" formControlName="help" id="help">
                          <label class="form-check-label d-inline" for="help">
                            <b>{{ t('Help Request') }}</b> {{ t('The worker can request help using a button in the app, but also a discreet help or voice controls.') }}
                          </label>
                        </div>
                    </li>
                    <li class="list-group-item">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" formControlName="timed_activity" id="timed_activity">
                        <label class="form-check-label d-inline" for="timed_activity">
                          <b>{{ t('Timed Activity') }}</b> {{ t('A timed activity allows you to set a one-off timer for an activity. An alert is triggered if the activity timer expires and you do not extend it or do not mark the activity as complete when finished.') }}
                        </label>
                      </div>
                  </li>
                  <li class="list-group-item">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" formControlName="panic_button" id="panic_button">
                      <label class="form-check-label d-inline" for="panic_button">
                        <b>{{ t('Panic Button') }}</b>&nbsp;{{ t("Allow the Panic / Help Button to appear without needing the worker to Start a Shift. All the worker has to do is make sure they're logged in to request Help.") }}
                      </label>
                    </div>
                  </li>
                  <li class="list-group-item">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" formControlName="shake" id="shake">
                      <label class="form-check-label d-inline" for="shake">
                        <b>{{ t('Shake for Help') }}</b> {{ t('The worker can shake their phone to request help.') }}
                      </label>
                    </div>
                </li>
                @if(okService.isSuperAdmin()){
                <li class="list-group-item">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" formControlName="sosbutton" id="sosbutton">
                    <label class="form-check-label d-inline" for="sosbutton">
                      <b>{{ t('SOS Button') }}</b> {{ t('The worker can press the power button multiple times to request help.') }}
                    </label>
                  </div>
                </li>
              }
                @if(okService.isSuperAdmin()){
                  <li class="list-group-item">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" formControlName="two_way_audio" id="two_way_audio">
                      <label class="form-check-label d-inline" for="two_way_audio">
                        <b>{{ t('Alert Audio') }}</b> {{ t('When a help alert is triggered, an audio line will be opened between the worker and a monitor phone number.') }}
                      </label>
                    </div>
                  </li>
                }
                          </ul>
                      </div>
                  </div>
                  <div class="col">

                      <div class="card">
                          <div class="card-header">
                            {{ t('Integrations') }}
                          </div>
                          <ul class="list-group list-group-flush">
                              <li class="list-group-item">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" formControlName="zoleo" id="zoleo">
                                    <label class="form-check-label d-inline" for="zoleo">
                                      <b>{{ t('ZOLEO Devices') }}</b> &nbsp;&nbsp;<span class="badge bg-success"><i class="fas fa-check"></i> {{ t('Partner') }} </span> {{ t('Link a ZOLEO device to the worker account so they can check in and update their location remotely.') }}
                                    </label>
                                    <button type="button" class="btn btn-link d-inline p-0 m-0" (click)="goToWorker('zoleo')" *ngIf="features.zoleo">{{ t('View Workers') }}</button>
                                </div>
                                <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['zoleo']">
                                  &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['zoleo']}}
                                </div>
                              </li>
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="what3words" id="what3words">
                                      <label class="form-check-label d-inline" for="what3words">
                                        <b>{{ t('what3words') }}</b> {{ t('OK Alone has partnered with what3words to provide worker locations in their 3 word format.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" routerLink="/settings/w3w" *ngIf="features.what3words">{{ t('View') }}</button>
                                  </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['what3words']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['what3words']}}
                                  </div>
                              </li>
                              <li class="list-group-item">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" formControlName="ihelp" id="ihelp">
                                    <label class="form-check-label d-inline" for="ihelp">
                                      <b>{{ t('iHelp Devices') }}</b> {{ t('Link an iHelp device to the worker account so they can send a Help Request via their device.') }}
                                    </label>
                                    <button type="button" class="btn btn-link d-inline p-0 m-0" (click)="goToWorker('ihelp')" *ngIf="features.ihelp">{{ t('View Workers') }}</button>
                                </div>
                                <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['ihelp']">
                                  &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['ihelp']}}
                                </div>
                              </li>
                              <li class="list-group-item">
                                  <div class="form-check">
                                      <input class="form-check-input" type="checkbox" formControlName="spot" id="spot">
                                      <label class="form-check-label d-inline" for="spot">
                                        <b>{{ t('SPOT Devices') }}</b> {{ t('Link a SPOT device to the worker account so they can check in and update their location remotely.') }}
                                      </label>
                                      <button type="button" class="btn btn-link d-inline p-0 m-0" (click)="goToWorker('spot')" *ngIf="features.spot">{{ t('View Workers') }}</button>
                                  </div>
                                  <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['spot']">
                                    &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['spot']}}
                                  </div>
                              </li>
                              <li class="list-group-item">
                                <div class="form-check">
                                  <input class="form-check-input" type="checkbox" formControlName="teams_notifications" id="teams_notifications">
                                  <label class="form-check-label" for="teams_notifications">
                                    <b>{{ t('Teams Alert Notifications') }}</b> {{ t('Send Alert notifications through to a Teams Channel. If your staff use Teams then they have another option to receive alerts on top of SMS, Calls, and Email. This helps ensure alerts are actioned as soon as possible and workers are kept safe.') }}
                                  </label>
                                </div>
                                <div class="alert alert-success m-0 p-1 text-wrap d-inline" role="alert" *ngIf="info['teams_notifications']">
                                  &nbsp;<i class="fa-solid fa-circle-info"></i> {{info['teams_notifications']}}
                                </div>
                              </li>
                              <li class="list-group-item">
                                <div class="form-check">
                                  <input class="form-check-input" type="checkbox" formControlName="app_connectivity" id="app_connectivity">
                                  <label class="form-check-label" for="app_connectivity">
                                    <b>{{ t('Worker Connectivity View') }}</b> {{ t('Provide better insights on your workers app connectivity. Including their connection status, battery life and signal strength.') }}
                                  </label>
                                </div>
                              </li>
                              <li class="list-group-item">
                                <div class="form-check">
                                  <input class="form-check-input" type="checkbox" formControlName="app_links" id="app_links">
                                  <label class="form-check-label" for="app_links">
                                    <b>{{ t('Safety Links') }}</b> {{ t('Create safety links for workers in the app. For example links to your company website, assessment forms or a link to a safety video.') }}
                                  </label>
                                </div>
                              </li>
                          </ul>
                      </div>
                  </div>
              </div>


              <c-row>
                <c-col xs="12" class="mt-3">
                  <button cButton class="px-4 btn-info text-white" type="submit">
                    <i class="fa-solid fa-check"></i> {{ t('Update your Feature Settings') }}
                  </button>
                </c-col>
              </c-row>

      </form>
  </ng-container>


  </c-card-body>
</c-card>
